export default "__VITE_ASSET__D5$v2eTH__"